import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

/**
 * Componente que redirige la ruta raíz "/" según el estado de autenticación
 * - Si hay sesión activa -> /home
 * - Si no hay sesión -> /login
 */
const RootRedirect = () => {
  const { user, loading } = useAuth();

  // Mostrar spinner mientras se verifica la autenticación
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: 'linear-gradient(135deg, #1A237E 0%, #3949AB 100%)'
        }}
      >
        <CircularProgress sx={{ color: 'white' }} size={60} />
      </Box>
    );
  }

  // Redirigir según estado de autenticación
  return user ? <Navigate to="/home" replace /> : <Navigate to="/login" replace />;
};

export default RootRedirect;
